import { useQuery } from "@tanstack/react-query";
import { getMailchimpContactFields } from "../../api/bIntegrationsApi";

export const useGetMailchimpContactFields = (audienceId, organisationId) => {
  return useQuery({
    queryKey: ["mailchimp-contact-fields", audienceId, organisationId],
    queryFn: () => getMailchimpContactFields(audienceId, organisationId),
    enabled: !!audienceId && !!organisationId,
  });
};